import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Signal,
    WritableSignal,
    effect,
    inject,
    signal,
    viewChild,
} from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { RouterLink } from "@angular/router";
import { AchievementBackofficeViewModel } from "@playcharge/common/models/backend/achievements/backoffice/achievement-backoffice-view-model";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { ComponentRoutes } from "../../../models/constants/component-routes";
import { MatMenuModule } from "@angular/material/menu";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { AchievementsStore } from "../../../stores/achievements/achievements-store";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
    selector: "app-achievements",
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        RouterLink,
    ],
    templateUrl: "./achievements.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AchievementsComponent {
    private _matSort: Signal<MatSort | undefined> = viewChild(MatSort);

    public achievementsStore: AchievementsStore = inject(AchievementsStore);

    public displayedColumns: WritableSignal<string[]> = signal<string[]>([
        "logo",
        "title",
        "active",
        "actions",
    ]);
    public dataSource: MatTableDataSource<AchievementBackofficeViewModel> =
        new MatTableDataSource<AchievementBackofficeViewModel>();

    public ComponentRoutes: typeof ComponentRoutes = ComponentRoutes;

    constructor() {
        effect(() => {
            if (this._matSort()) {
                this.dataSource.sort = this._matSort()!;
            }
        });

        effect(() => {
            this.dataSource.data = this.achievementsStore.entities();
        });
    }

    public ngAfterViewInit(): void {
        this.dataSource.filterPredicate = this.filterPredicate;
    }

    public applyFilter(event: KeyboardEvent): void {
        this.dataSource.filter = (event.target as HTMLInputElement).value;
    }

    private filterPredicate(achievement: AchievementBackofficeViewModel, filter: string): boolean {
        return (
            achievement.title?.trim().toLocaleLowerCase().includes(filter.trim().toLowerCase()) ??
            false
        );
    }
}
